"use client";

import { useOptionTradeType } from "#/store/options/tradePanel/optionTradeType";

import { OptionLimitOrder } from "./components/OptionLimitOrder/OptionLimitOrder";
import { OptionMarketOrder } from "./components/OptionMarketOrder/OptionMarketOrder";
import { OptionRFQ } from "./components/OptionRFQ/OptionRFQ";

export const OptionTradeDetails: React.FC = () => {
  const { isMarket, isLimit, isRFQ } = useOptionTradeType();

  return (
    <>
      {isMarket && <OptionMarketOrder />}
      {isLimit && <OptionLimitOrder />}
      {isRFQ && <OptionRFQ />}
    </>
  );
};
